import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
import { reviews } from '../data/mock';

export default function Reviews() {
  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-indigo-50 border border-indigo-100 text-indigo-700 text-sm font-semibold mb-4">
            <ShieldCheck className="w-4 h-4" />
            Verified Customer Reviews
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            What Real Brands Say
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Honest feedback from founders and operators we work with every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <article
              key={r.name}
              className="bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-lg hover:border-indigo-200 transition-all duration-200 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: r.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed flex-1">&ldquo;{r.text}&rdquo;</p>
              <div className="mt-5 pt-5 border-t border-slate-100">
                <div className="flex flex-wrap gap-2 mb-3">
                  <span className="px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 text-xs font-semibold">
                    {r.category}
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-slate-100 text-slate-600 text-xs font-medium">
                    {r.orderRange}
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full brand-gradient flex items-center justify-center text-white font-bold text-sm">
                    {r.initials}
                  </div>
                  <div className="flex-1">
                    <p className="font-bold text-slate-900 text-sm">{r.name}</p>
                    <p className="text-xs text-slate-500">{r.company}</p>
                  </div>
                  <p className="text-xs text-slate-400">Verified · {r.date}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex items-center justify-center gap-6">
          <div className="flex items-center gap-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" />
            ))}
            <span className="font-bold text-slate-900 ml-1">5.0 average rating</span>
          </div>
          <span className="hidden sm:block w-px h-6 bg-slate-200" />
          <p className="hidden sm:block text-slate-600 text-sm font-medium">
            Trusted by growing Shopify and D2C brands
          </p>
        </div>
      </div>
    </section>
  );
}
